import { Tag, Handshake, UserPlus, Star } from 'lucide-react';
import { Link } from '@tanstack/react-router';
import { useTranslation } from '../../i18n';
import styles from './ActivityFeedCard.module.css';

interface ActivityEvent {
  id: string;
  type: string;
  userId: string;
  userDisplayName: string;
  userAvatarUrl: string | null;
  userProfileSlug: string | null;
  data: Record<string, unknown>;
  createdAt: string;
}

function getEventIcon(type: string) {
  switch (type) {
    case 'item_listed': return Tag;
    case 'trade_completed': return Handshake;
    case 'member_joined': return UserPlus;
    case 'item_showcased': return Star;
    default: return Tag;
  }
}

function timeAgo(dateStr: string): string {
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'now';
  if (mins < 60) return `${mins}m`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days}d`;
  return `${Math.floor(days / 30)}mo`;
}

export function ActivityFeedCard({ event }: { event: ActivityEvent }) {
  const { t } = useTranslation();
  const Icon = getEventIcon(event.type);
  const eventKey = `activity.event.${event.type}` as any;

  const profileLink = event.userProfileSlug
    ? `/profile/${event.userProfileSlug}`
    : null;

  const itemName = (event.data.itemName as string) || '';

  let description = t(eventKey) || event.type;
  if (itemName) {
    description = description.replace('{item}', itemName);
  }

  return (
    <div className={styles.card}>
      <div className={styles.iconWrap}>
        <Icon size={16} strokeWidth={1.75} />
      </div>
      <div className={styles.content}>
        <div className={styles.text}>
          {profileLink ? (
            <Link to={profileLink} className={styles.userName}>
              {event.userDisplayName}
            </Link>
          ) : (
            <span className={styles.userName}>{event.userDisplayName}</span>
          )}
          {' '}
          <span className={styles.desc}>{description}</span>
          {itemName && <span className={styles.itemName}> "{itemName}"</span>}
        </div>
        <div className={styles.time}>{timeAgo(event.createdAt)}</div>
      </div>
    </div>
  );
}
